/* SmartTap – ATC normalizer v3: DOM-scan file attach + JSON->FormData + post-move */
document.addEventListener('DOMContentLoaded', function () {
  const LABELS = ['Your Design', 'Upload your design here'];

  function pickLiveFile() {
    for (const lbl of LABELS) {
      const sel = `input[type="file"][name="properties[${lbl}]"], input[type="file"][name$="[properties][${lbl}]"]`;
      for (const inp of document.querySelectorAll(sel)) {
        if (inp.files && inp.files[0]) return { file: inp.files[0], label: lbl };
      }
    }

    for (const inp of document.querySelectorAll('input[type="file"]')) {
      if (inp.files && inp.files[0]) {
        const m = inp.name && inp.name.match(/\[properties\]\[(.+?)\]$/);
        return { file: inp.files[0], label: m ? m[1] : LABELS[0] };
      }
    }

    return null;
  }

  function pickTargetIndex(items) {
    let i = items.findIndex((it) => !it.selling_plan && !(it.properties && it.properties._Gifted));
    if (i !== -1) return i;

    i = items.findIndex((it) => !(it.properties && it.properties._Gifted));
    return i !== -1 ? i : Math.max(0, items.length - 1);
  }

  function buildFDFromJSON(json, chosen) {
    const fd = new FormData();
    const items = Array.isArray(json.items) ? json.items : [];
    const t = pickTargetIndex(items);

    items.forEach((it, i) => {
      if (it.id) fd.append(`items[${i}][id]`, String(it.id));
      fd.append(`items[${i}][quantity]`, String(it.quantity || 1));
      if (it.selling_plan) fd.append(`items[${i}][selling_plan]`, String(it.selling_plan));

      const props = it.properties || {};
      for (const k in props) {
        if (Object.hasOwn(props, k) && !LABELS.includes(k)) {
          fd.append(`items[${i}][properties][${k}]`, String(props[k]));
        }
      }

      if (i === t && chosen) {
        fd.append(`items[${i}][properties][${chosen.label}]`, chosen.file);
      }
    });

    for (const k in json) {
      if (k !== 'items' && json[k] != null) fd.append(k, String(json[k]));
    }

    return fd;
  }

  function attachToFormData(bodyFD, chosen) {
    const fd = new FormData();
    bodyFD.forEach((v, k) => fd.append(k, v));

    const idx = [];
    for (const k of fd.keys()) {
      const m = /^items\[(\d+)\]\[id\]$/.exec(k);
      if (m) idx.push(+m[1]);
    }
    idx.sort((a, b) => a - b);

    for (const [k, v] of fd.entries()) {
      if (/\bproperties\[.+?\]/.test(k) && v instanceof File) return null;
    }

    if (!chosen) return null;

    if (idx.length) {
      let t = idx[0];
      for (const i of idx) {
        if (!fd.get(`items[${i}][properties][_Gifted]`)) {
          t = i;
          break;
        }
      }
      fd.set(`items[${t}][properties][${chosen.label}]`, chosen.file);
    } else {
      fd.set(`properties[${chosen.label}]`, chosen.file);
    }

    return fd;
  }

  function normalize(input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    if (!url || !url.includes('/cart/add.js') || !init) return { input, init };

    const chosen = pickLiveFile();
    if (!chosen) return { input, init };

    const body = init.body;

    if (body instanceof FormData) {
      const fd2 = attachToFormData(body, chosen);
      if (!fd2) return { input, init };

      const ni = Object.assign({}, init, { body: fd2 });
      if (ni.headers) delete ni.headers['Content-Type'];
      return { input, init: ni };
    }

    try {
      const json =
        typeof body === 'string' || body instanceof String
          ? JSON.parse(body)
          : Object.prototype.toString.call(body) === '[object Object]'
            ? body
            : null;

      if (!json) return { input, init };

      const fd = buildFDFromJSON(json, chosen);
      const ni = Object.assign({}, init, { body: fd });
      if (ni.headers) delete ni.headers['Content-Type'];
      return { input, init: ni };
    } catch {
      return { input, init };
    }
  }

  if (!window.__st_norm_fetch) {
    window.__st_norm_fetch = window.fetch;
    window.fetch = function (i, init) {
      const r = normalize(i, init);
      const p = window.__st_norm_fetch(r.input, r.init);
      if ((typeof r.input === 'string' ? r.input : r.input?.url || '').includes('/cart/add.js')) {
        p.then(() => setTimeout(postMoveIfNeeded, 120)).catch(() => {});
      }
      return p;
    };
  }

  if (!window.__st_norm_xopen) {
    window.__st_norm_xopen = XMLHttpRequest.prototype.open;
    window.__st_norm_xsend = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (m, u) {
      this.__u = u;
      return window.__st_norm_xopen.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function (data) {
      if ((this.__u || '').includes('/cart/add.js')) {
        try {
          const chosen = pickLiveFile();
          if (chosen && (typeof data === 'string' || Object.prototype.toString.call(data) === '[object Object]')) {
            const json = typeof data === 'string' ? JSON.parse(data) : data;
            const fd = buildFDFromJSON(json, chosen);
            return window.__st_norm_xsend.call(this, fd);
          }
        } catch {}
      }
      return window.__st_norm_xsend.apply(this, arguments);
    };
  }

  async function getCart() {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function setProp(line, key, val) {
    const body = new URLSearchParams();
    body.set('line', String(line));
    body.set(`properties[${key}]`, val || '');
    await fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body,
    });
  }

  async function postMoveIfNeeded() {
    const cart = await getCart();
    if (!cart.items?.length) return;

    let src = null;
    let url = null;
    let label = null;

    for (const lbl of LABELS) {
      for (let i = 0; i < cart.items.length; i++) {
        const p = cart.items[i].properties || {};
        if (p[lbl]) {
          src = i + 1;
          url = p[lbl];
          label = lbl;
          break;
        }
      }
      if (src) break;
    }

    if (!src || !url) return;

    let dstIdx = cart.items.findIndex((it) => !it.selling_plan_allocation && !(it.properties && it.properties._Gifted));
    if (dstIdx === -1) dstIdx = cart.items.findIndex((it) => !(it.properties && it.properties._Gifted));
    if (dstIdx === -1) return;

    const dst = dstIdx + 1;
    if (dst === src) return;

    await setProp(dst, label, url);
    await setProp(src, label, '');

    const drawer = document.querySelector('cart-drawer');
    if (drawer) {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  console.log('[SmartTap] ATC normalizer v3 armed');
});
